import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";

import ConsentManager from "@/modules/frontend/components/ConsentManager";
import PopUp from "@/modules/frontend/components/PopUp";
import BookADemo from "@/modules/frontend/components/BookADemo";

import GlobalTradeNetwork1 from "@/assets/images/webp/global-network-img-1.webp";
import GlobalTradeNetwork2 from "@/assets/images/webp/global-network-img-2.webp";
import GlobalTradeNetwork3 from "@/assets/images/webp/global-network-img-3.webp";
import GlobalTradeNetwork4 from "@/assets/images/webp/global-network-img-4.webp";
import GlobalTradeNetwork5 from "@/assets/images/webp/global-network-img-5.webp";
import GlobalTradeNetwork6 from "@/assets/images/webp/global-network-img-6.webp";

import { motion } from "framer-motion";

const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("en");

  const handleQuoteClick = () => {
    setSmallModalShow(true);
  };

  useEffect(() => {
    setSelectedLanguage(localStorage.getItem("web_lang"));
  }, []);

  return (
    <>
      <SeoHelmet
        title={seoConfig.globalNetwork.title}
        description={seoConfig.globalNetwork.description}
        keywords={seoConfig.globalNetwork.keywords}
        author={seoConfig.globalNetwork.author}
      />
      <button
        className="btn outline small sticky-btn"
        onClick={handleQuoteClick}
        type="button"
      >
        Book A Demo
      </button>
      <div>
        <section className="global-trade-netwok">
          {/* inner banner wrape START  */}
          <div className="inner-banner">
            <div className="container">
              {
                selectedLanguage === "en" ? <div className="content-wrape desk-hide">
                  <h2>
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Global</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Business</motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Network</motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Connect Buyers, Suppliers & Logistics Partners.</motion.p>
                </div> : <div className="content-wrape desk-hide">
                  <h2>
                    <span className={`light`}>Global</span>
                    <span className={`blue-text`} > Trade</span>
                    <span className={`black`}> Network</span>
                  </h2>
                  <p className={``}>Connect Buyers, Suppliers & Logistics Partners.</p>
                </div>
              }

            </div>
          </div>
          {/* inner banner wrape END  */}

          {/* inner page content START */}
          <div className="inner-page-content-wrape global-trade-network-page">
            <div className='container'>
              {
                selectedLanguage === "en" ? <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <motion.span className={`light animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Global</motion.span>
                    <motion.span className={`blue-text animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Business</motion.span>
                    <motion.span className={`black animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    > Network</motion.span>
                  </h2>
                  <motion.p className={`animate-child`}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Connect Buyers, Suppliers & Logistics Partners.</motion.p>
                </div> : <div className="content-wrape mobile-show page-head">
                  <h2 className="mobile-head-text">
                    <span className={`light`} >Global</span>
                    <span className={`blue-text`}> Trade</span>
                    <span className={`black`} > Network</span>
                  </h2>
                  <p className={``} >Connect Buyers, Suppliers & Logistics Partners.</p>
                </div>
              }


              <div className="subtext-wrape">
                <div className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.h1 className={`animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}>Smarter Global Trade Solutions</motion.h1>
                  </div>
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <motion.p className={`medium-size animate-child`}
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Orex Trade World Inc connects buyers, suppliers and logistics partners through a trusted global network. We simplify international trade with reliable partnerships, transparent processes and insights that help your business grow confidently across borders.</motion.p>
                  </div>
                </div>
              </div>

              <div className='row'>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12'>
                  <div className='img-wrape'>
                    <motion.img src={GlobalTradeNetwork1} alt='Global B2B Network' loading="lazy" className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    ></motion.img>
                  </div>
                </div>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 d-flex align-items-center'>
                  <div className='content-wrape'>
                    <div className="head-text">
                      <motion.h2 className="head animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Global Business Network
                      </motion.h2>
                    </div>

                    <motion.h6 className="varient animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Connect Buyers, Suppliers & Logistics Partners</motion.h6>

                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Orex Trade World Inc is a leading global business network which connects buyers, suppliers and logistics partners across 80+ countries. Our network empowers businesses to expand internationally, access verified trade leads and build trustworthy partnerships that drive growth.</motion.p>

                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Whether you are a buyer seeking reliable suppliers, a supplier looking for verified buyers or a logistics partner supporting seamless shipping, Orex Trade provides the tools, insights and connections you need to succeed in international trade.</motion.p>
                    <motion.p className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}>By joining our global business network, members gain access to real-time market intelligence, secure trade systems and global logistics solutions. Every connection is verified to ensure authenticity, minimize risk and maximize business opportunities worldwide.</motion.p>
                  </div>
                </div>
              </div>

              {/* verification global network START */}
              <div className="verification-global-wrape" id="verified-global-network">
                <div className="row">
                  <div className="col-xxl-12">
                    <div className="head-text center">
                      <motion.h2 className="head center animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >
                        Verified Global Network
                      </motion.h2>
                      <motion.p className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Orex Trade connects you with a trusted community of verified buyers, suppliers and logistics partners worldwide. Every member undergoes a strict verification process to ensure authenticity, reliability and credibility - giving you the confidence to trade securely.</motion.p>

                      <motion.p className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Our verified network helps businesses reduce risk, avoid fraudulent connections and build lasting professional relationships across industries. Whether you’re sourcing products or offering services, you can confidently connect with genuine partners in over 80 countries, ensuring your trade journey is safe and successful.</motion.p>
                    </div>
                  </div>

                  <div className="col-xxl-12">
                    <motion.h5
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Key Highlights</motion.h5>
                    <div className="row custom-scroll-row">
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={GlobalTradeNetwork2} alt='Global B2B Network' loading="lazy" className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Verified and trustworthy global business connections</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={GlobalTradeNetwork3} alt='Global B2B Network' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >Secure and transparent trade environment</motion.p>
                          </div>
                        </div>
                      </div>
                      <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-sm-6">
                        <div className="product">
                          <motion.img src={GlobalTradeNetwork4} alt='Global B2B Network' loading="lazy"
                            className="animate-child"
                            initial="hidden"
                            whileInView="visible"
                            viewport={{ once: true, amount: 0.1 }}
                            custom={0.1}
                            variants={fadeUpVariant}
                          ></motion.img>
                          <div className="overlays">
                            <motion.p
                              className="animate-child"
                              initial="hidden"
                              whileInView="visible"
                              viewport={{ once: true, amount: 0.1 }}
                              custom={0.1}
                              variants={fadeUpVariant}
                            >80+ countries covered across multiple industries</motion.p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* verification global network END */}
            </div>


            {/* globalPartnerwrape START */}
            <div className="global-partner-wrape" id="global-logistics-partners">
              <div className="img-wrape">
                <motion.img src={GlobalTradeNetwork5} alt='Global partner' loading="lazy"
                  className="animate-child"
                  initial="hidden"
                  whileInView="visible"
                  viewport={{ once: true, amount: 0.1 }}
                  custom={0.1}
                  variants={fadeUpVariant}
                ></motion.img>
              </div>
              <div className="detail-wrape">
                <div className="inner-pad">
                  <div className="head-text">
                    <motion.h2 className="head animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      Global Logistics Partners
                    </motion.h2>
                  </div>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Efficient logistics are essential for successful international trade and Orex Trade simplifies that process. Orex Trade connects businesses with experienced global logistics partners who ensure smooth, timely and secure delivery of goods worldwide.</motion.p>
                  <motion.p
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >From freight forwarding and customs support to last-mile delivery coordination, our logistics network helps you streamline operations and expand into new markets without delays or complexity.</motion.p>
                  <motion.h5
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  >Key Highlights</motion.h5>
                  <ul>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Access trusted global logistics service providers
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Simplify your supply chain with end-to-end coordination
                    </motion.li>
                    <motion.li
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >
                      <i className="sprite"></i>
                      Support for domestic and international trade routes
                    </motion.li>
                  </ul>
                </div>
              </div>
            </div>
            {/* globalPartnerwrape END */}

            {/* market-inteligence-wrape START */}
            <div className="container market-inteligence-wrape" id="market-intelligence">
              <div className="row">
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div className="detail-wrape">
                    <div className="inner-pad">
                      <div className="head-text">
                        <motion.h2 className="head animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          Market Intelligence & Growth Opportunities
                        </motion.h2>
                      </div>
                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Stay ahead of the competition with data-driven insights and trade intelligence powered by Orex Trade. Our global business network provides members with real-time market trends, buyer-supplier activity reports and industry analytics to help you make informed business decisions.</motion.p>

                      <motion.p
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >With these insights, you can identify new markets, discover high-potential partners and develop effective trade strategies that drive measurable growth. Orex Trade empowers you to turn information into opportunity and accelerate your global expansion.</motion.p>
                      <div className="clearfix"></div>
                      <motion.h5
                        className="animate-child"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.1 }}
                        custom={0.1}
                        variants={fadeUpVariant}
                      >Key Highlights</motion.h5>
                      <ul>
                        <motion.li
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Real-time trade insights and analytics
                        </motion.li>
                        <motion.li
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}>
                          <i className="sprite"></i>
                          Data-driven decision-making for business expansion
                        </motion.li>
                        <motion.li
                          className="animate-child"
                          initial="hidden"
                          whileInView="visible"
                          viewport={{ once: true, amount: 0.1 }}
                          custom={0.1}
                          variants={fadeUpVariant}
                        >
                          <i className="sprite"></i>
                          Identify growth markets and emerging trade opportunities
                        </motion.li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <motion.img src={GlobalTradeNetwork6} alt='Global B2B Network' loading="lazy"
                    className="animate-child"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.1 }}
                    custom={0.1}
                    variants={fadeUpVariant}
                  ></motion.img>
                </div>
              </div>
            </div>
            {/* market-inteligence-wrape END */}

            {/* gray wrape START */}
            <div className="gray-wrape">
              <div className="container">
                <div className="row">
                  <div className="col-xxl-12">
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >At Orex Trade, our Global Business Network is designed to help businesses of all sizes connect, collaborate and thrive. By combining verified partnerships, trusted Logistics solutions and intelligent market insights, we empower you to trade smarter, safer and more efficiently anywhere in the world.</motion.p>
                    <motion.p
                      className="animate-child"
                      initial="hidden"
                      whileInView="visible"
                      viewport={{ once: true, amount: 0.1 }}
                      custom={0.1}
                      variants={fadeUpVariant}
                    >Orex Trade - Your Trusted Partner in Global Business Growth.</motion.p>
                  </div>
                </div>
              </div>
            </div>
            {/* gray wrape END */}

          </div>
          {/* inner page content END */}
        </section>
      </div>
      <ConsentManager data={""} />

      {smallmodalShow && (
        <PopUp
          title="Book A Demo"
          smallmodalShow={smallmodalShow}
          setSmallModalShow={setSmallModalShow}
          className="book-demo"
        // onSubmit={handleRegistrationPopup}
        // okButtonLabel={isDemoUser ? 'GO TO INQUIRIES' : isPreKYCUser ? 'GO TO PROFILE' : isViewer ? 'GO TO INQUIRIES' : isEndUser ? 'GO TO INQUIRIES' : 'REGISTER NOW' 
        // }
        >
          <BookADemo
            setSmallModalShow={setSmallModalShow} />
        </PopUp>
      )}
      <ToastContainer />
    </>
  );
};

export default Index;